var map = {
	"./ETH-logo.png": 817,
	"./KPR-logo.png": 818,
	"./LBD-logo.png": 819,
	"./LBI-logo.png": 820,
	"./LKR-logo.png": 821,
	"./UNI-logo.png": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 223;